var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.copy.apply(null, arguments)}}},[_c('i',{staticClass:"icon ion-ios-clipboard"}),_vm._v("\n    "+_vm._s(_vm._f("lang")('copy.toClipboard'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }